import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Loader from "examples/Loader";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import CreateAITokenPlanModal from "./components/aiTokenPlan/CreateAITokenPlanModal";
import EditAITokenPlanModal from "./components/aiTokenPlan/EditAITokenPlanModal";
import DeleteAITokenPlanModal from "./components/aiTokenPlan/DeleteAITokenPlanModal";

const CURRENCY_SYMBOLS = {
  gbp: "£",
  usd: "$",
};

const formatCost = (amount, currency) => {
  const sym = CURRENCY_SYMBOLS[(currency || "gbp").toLowerCase()] || "";
  return `${sym}${Number(amount || 0)}`;
};

export default function AITaskTokens() {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [plans, setPlans] = useState([]);
  const [loader, setLoader] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);
  const [editPlan, setEditPlan] = useState(null);
  const [deletePlan, setDeletePlan] = useState(null);

  const fetchPlans = async () => {
    if (!agency?._id) return;
    setLoader(true);
    const { response } = await AppService.aiTokenPlans.list({
      query: `agency_id=${agency._id}`,
      toaster: false,
    });
    if (response?.success) setPlans(response.data || []);
    setLoader(false);
  };

  useEffect(() => {
    if (agency?._id) fetchPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agency?._id]);

  if (loader) return <Loader />;

  return (
    <div style={{ padding: "0 4px" }}>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <button
          onClick={() => setCreateOpen(true)}
          style={{
            background: "#1E1E1E",
            color: "#fff",
            padding: "10px 22px",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <span style={{ fontSize: 18, lineHeight: 1 }}>+</span> AI Task  Plan
        </button>
      </div>

      <Table sx={{ border: "1px solid #d9d9d9", marginTop: "16px" }}>
        <TableHead sx={{ width: "100%", backgroundColor: "#e9e9e9", display: "table-header-group" }}>
          <TableRow sx={{ borderRadius: "8px 8px 0px 0px" }}>
            <TableCell style={{ width: "30%" }}>Task Plan Name</TableCell>
            <TableCell style={{ width: "30%" }}>Number of AI Task </TableCell>
            <TableCell style={{ width: "30%" }}>Cost of AI Task</TableCell>
            <TableCell style={{ width: "10%" }} align="right">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {plans.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} align="center" sx={{ color: "#757575" }}>
                No AI Task  plans yet. Click &quot;+ AI Task  Plan&quot; to add one.
              </TableCell>
            </TableRow>
          ) : (
            plans.map((plan) => (
              <TableRow key={plan._id}>
                <TableCell sx={{ color: "#1E1E1E" }}>
                  {plan?.planName || ''}
                </TableCell>
                <TableCell sx={{ color: "#1E1E1E" }}>
                  {Number(plan.tokens).toLocaleString()}
                </TableCell>
                <TableCell sx={{ color: "#1E1E1E" }}>
                  {formatCost(plan.amount, plan.currency)}
                </TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => setEditPlan(plan)} size="small">
                    <EditOutlinedIcon fontSize="small" sx={{ color: "#1E1E1E" }} />
                  </IconButton>
                  <IconButton onClick={() => setDeletePlan(plan)} size="small">
                    <DeleteOutlineIcon fontSize="small" sx={{ color: "#DC2626" }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      <CreateAITokenPlanModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        agency_id={agency?._id}
        onSaved={fetchPlans}
      />
      <EditAITokenPlanModal
        open={!!editPlan}
        onClose={() => setEditPlan(null)}
        plan={editPlan}
        onSaved={fetchPlans}
      />
      <DeleteAITokenPlanModal
        open={!!deletePlan}
        onClose={() => setDeletePlan(null)}
        plan={deletePlan}
        onDeleted={fetchPlans}
      />
    </div>
  );
}
